import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';

import { MdbModalRef } from 'mdb-angular-ui-kit/modal';


@Component({
  selector: 'app-password',
  standalone: true,
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss'],
  imports: [MdbFormsModule, ReactiveFormsModule]
})
export class PasswordComponent implements OnInit {
  formUtente = new FormGroup({
    password: new FormControl(''),    
  })

  titolo: string = 'Modifica Password'

  constructor(public modalRef: MdbModalRef<PasswordComponent>) { }

  ngOnInit(): void {
  }

  close() {
    let u = this.formUtente.value
    console.log(u)
    this.modalRef.close(u.password)
  }

}
